import {userCanCreateAssetProjects} from '@netx/core-asset-project/enablers';
import {currentCartIsNotEmpty} from './currentCartIsNotEmpty';

export const canReviewCurrentCart = (): boolean =>
	currentCartIsNotEmpty() && userCanCreateAssetProjects();

export default canReviewCurrentCart;
